import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuCircleBtn from './MenuCircleBtn';

const MenuStand = (props) => {
   return (
      <div className="Accordians">
         <Accordion style={{ borderRadius: "0px" }} disabled={props.hides} onChange={props.onChanged} expanded={props.expanded}>
            <AccordionSummary id="colorBtn" tabIndex="1"
               expandIcon={<ExpandMoreIcon />} >
               <Typography className="accordion-headers AccordiansHeader" style={{ fontWeight: "700" }}>{props.name}</Typography>
            </AccordionSummary>
            <AccordionDetails tabIndex="1" id="Stand1" onKeyPress={props.onWhiteBtnClick} onClick={props.onWhiteBtnClick} >
               <MenuCircleBtn submenu="Articulating" source="./img/clr_1.png" />
            </AccordionDetails>
            <AccordionDetails tabIndex="-1" id="Stand2" onKeyPress={props.onBlackBtnClick} onClick={props.onBlackBtnClick}>
               <MenuCircleBtn id="blackBtns" submenu="Height Adjustible" source="./img/clr_2.png" />
            </AccordionDetails>
            <AccordionDetails tabIndex="-1" id="Stand3" onKeyPress={props.onBlackBtnClick} onClick={props.onBlackBtnClick}>
               <MenuCircleBtn id="blackBtns" submenu="Pedestal" source="./img/clr_2.png" />
            </AccordionDetails>
         </Accordion>
      </div >
   );

}
export default MenuStand;